import React, { useRef, useCallback } from 'react';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { keyCodes } from '@yme/utils/constants';
import { TabsWrapper, TabsInner, TabItem, TabTitleStyled, TabAmountStyled } from './styled';
import { useCalculateScaleValue } from './useCalculateScaleValue';
/**
 * Tabs component for for Tablet and Desktop Views
 *
 * @tabData Data for tabs component
 * @activeTab Active Tab (object with props for tab)
 * @onSetActiveTab setState function
 * @colorTheme prop become from store (which gets from page settings)
 *
 * @returns Component (JSX element) with all 'tabs' for Tablet and Desktop Views
 */
export function TabletTabs(props) {
    const { tabData, activeTab, onSetActiveTab, colorTheme = colorBrandYamahaRed } = props;
    const tabsHolderRef = useRef(null);
    const itemTabRef = useRef(null);
    const halfTabsCount = Math.floor((tabData.length - 1) / 2);
    const { scale, animationTabsHandler, isShowLeftGradient, isShowRightGradient } = useCalculateScaleValue({
        tabsHolderRef,
        itemTabRef,
        halfTabsCount,
    });
    const onClickHandler = useCallback((id) => {
        onSetActiveTab(id);
        animationTabsHandler(id);
    }, [animationTabsHandler, onSetActiveTab]);
    const keyDownHandler = (event, index) => {
        if (event.key === keyCodes.ENTER) {
            onClickHandler(index);
        }
    };
    return (React.createElement(TabsWrapper, { mb: "32px", as: FlexWrapper, ref: tabsHolderRef, isShowLeftGradient: isShowLeftGradient, isShowRightGradient: isShowRightGradient },
        React.createElement(TabsInner, { as: FlexWrapper, transformOption: scale }, tabData.map(({ entityId, tabTitle, amountLabel }) => (React.createElement(TabItem, { ref: itemTabRef, key: entityId, colorTheme: colorTheme, onClick: () => onClickHandler(entityId), isActiveTab: activeTab.entityId === entityId, tabIndex: 0, onKeyDown: (event) => keyDownHandler(event, entityId) },
            React.createElement(TabTitleStyled, { weight: 400 },
                tabTitle,
                amountLabel && React.createElement(TabAmountStyled, { weight: 500 }, amountLabel))))))));
}
TabletTabs.displayName = 'TabletTabs';
